/** What the plan import accepts: CAD drawings (DWG is converted on the server), SVG and plan images. */
export const PLAN_FILE_ACCEPT = '.dxf,.dwg,.png,.jpg,.jpeg,.webp,.bmp,.svg,.gif';
